module.exports = __webpack_public_path__ + "img/info.5b86db2d.png";